import axios from 'axios';

class Service {

  getRestClient(captchaResponse) {
    this.serviceInstance = axios.create({
      //baseURL: 'http://10.1.220.149:8090/eSigWebApp-web/api/', //Ovo sluzi za testiranje na android emulatoru, staviti ip adresu svog racunala
      //baseURL: 'http://localhost:8090/eSigWebApp-web/api/',
      baseURL: document.getElementById("endpoint").getAttribute("value"),
      timeout: document.getElementById("timeout").getAttribute("value"),
      headers: {
        'Content-Type': 'application/json',
        'Captcha-Response': captchaResponse
      },
    });
    return this.serviceInstance;
  }
}

export default (new Service());